module.exports = __webpack_public_path__ + "static/programming-icon-315eabfc1f67fa8843919f00a4303962.svg";